import type { ActiveID } from './types';

export const ACTIVE_ANNOTATION_ID: ActiveID = null;
